<template>
  <table v-if="items && items.length > 0" class="financial-overview-table">
    <thead>
      <tr>
        <th>{{ headerTitle }}</th>
        <th>{{ headerColumn1Title }}</th>
        <th>{{ headerColumn2Title }}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="item in items" :key="item.ID">
        <td>{{ item.ID }} <span v-if="item.ID">-</span> {{ item.Name }}</td>
        <td :class="{ 'financial-overview-table__negative': item.Price.Excl < 0 }">
          {{ i18n.n(item.Price.Excl, 'currency') }}
        </td>
        <td :class="{ 'financial-overview-table__negative': item.Price.Incl < 0 }">
          {{ i18n.n(item.Price.Incl, 'currency') }}
        </td>
      </tr>
    </tbody>

    <tfoot v-if="footerPrice">
      <tr>
        <td>{{ footerTitle }}</td>
        <td>{{ i18n.n(footerPrice.Excl, 'currency') }}</td>
        <td>{{ i18n.n(footerPrice.Incl, 'currency') }}</td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    footerTitle: { type: String, default: '' },
    footerPrice: { type: Object, default: null },
    headerColumn1Title: { type: String, default: '', required: false },
    headerColumn2Title: { type: String, default: '', required: false },
  },
  data() {
    return {
      dealerAccessories: [],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
.financial-overview-table {
  width: 100%;
  margin-bottom: 1rem;

  tfoot {
    font-weight: bold;
  }

  td,
  th {
    padding: 0;
  }

  th:first-child {
    width: 80%;
  }

  &__negative {
    color: red;
  }
}
</style>
